export const invoiceBalanceDue = (invoice) => Math.max(
  0,
  Number(invoice?.balance_due ?? (Number(invoice?.total || 0) - Number(invoice?.amount_paid || 0))),
);

// Evaluate the saved server response, not the editor's estimates. An unsent
// draft or a fully settled invoice must never prompt for an unsolicited send.
export const shouldOfferInvoiceResend = (previous, updated) => {
  const wasSent = Boolean(previous?.sent_at || previous?.status === "sent");
  const balance = invoiceBalanceDue(updated);
  return Boolean(updated?.id && wasSent && Number.isFinite(balance) && balance > 0.005);
};